<script lang="ts">
import { h, defineComponent, type VNode } from 'vue';

import CommonChip from '@/bundles/Common/components/chips/CommonChip.vue';

// The single definition of the Client Access badge. Two different statements render it:
// "this contact is a client user" (via ContactMemberChip) and "this contact is granted
// access to this occupier" (the contact record's occupiers card). Keeping one component
// means the label and colour can't drift between them.
export default defineComponent({
  name: 'ClientAccessChip',

  render (): VNode {
    return h(CommonChip, { color: 'warning' }, { default: () => [
      h('span', 'Client Access')
    ] });
  }
});
</script>
